export default "__VITE_ASSET__BIMF5Lu2__"